import { createAsyncThunk } from "@reduxjs/toolkit";
import { services } from "../../api"; // Using the billing service as it has getPatients

export const fetchPatients = createAsyncThunk(
  "patients/fetchPatients",
  async (
    { page, pageSize }: { page: number; pageSize: number },
    { rejectWithValue },
  ) => {
    try {
      const response = await services.patients.getPatients(page, pageSize);
      return response.content;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
